module.exports = __webpack_public_path__ + "static/media/Tempo.fc61e4d2.gif";